document.addEventListener('DOMContentLoaded', function () {
    // Vérifiez si l'URL contient 'a/statut-livraison'
    if (window.location.href.includes('a/statut-livraison')) {
        var checked = false;

        // Vérifiez immédiatement si le numéro est déjà présent
        var trackingNumberInfo = extractTrackingNumber();
        if (trackingNumberInfo) {
            duplicateTrackingNumber(trackingNumberInfo);
            checked = true;
        }

        // Si non trouvé initialement, vérifiez toutes les 1 seconde jusqu'à ce qu'il soit trouvé
        if (!checked) {
            var intervalId = setInterval(function () {
                var trackingNumberInfo = extractTrackingNumber();
                if (trackingNumberInfo) {
                    duplicateTrackingNumber(trackingNumberInfo);
                    clearInterval(intervalId); // Arrêtez l'intervalle une fois trouvé
                }
            }, 1000); // L'intervalle est réglé à 1 seconde
        }

        function extractTrackingNumber() {
            // Récupérez l'élément contenant les informations de suivi
            var trackingInfoElement = document.querySelector('#pp-tracking-page-app > div > div.pp_tracking_result > div.pp_tracking_right > ul > li.PP-SectionItem.PP-Section-CarrierInfo');
            if (trackingInfoElement) {
                var text = trackingInfoElement.textContent || trackingInfoElement.innerText;

                // Vérifiez les différents types de numéros de suivi
                var matchColissimo = text.match(/6A\d{11}/); // Recherche d'une séquence commençant par '6A' suivie de 11 chiffres
                var matchColisPrive = text.match(/Q10\w+/); // Recherche d'une séquence commençant par 'Q10' suivie de lettres et/ou chiffres
                var matchDPD = text.match(/06\d+/); // Recherche d'une séquence commençant par '06' suivie de chiffres

                if (matchColissimo) {
                    return { type: 'Colissimo', number: matchColissimo[0] };
                } else if (matchColisPrive) {
                    return { type: 'Colis Privé', number: matchColisPrive[0] };
                } else if (matchDPD) {
                    return { type: 'DPD', number: matchDPD[0] };
                }
            }
            return null;
        }

        function duplicateTrackingNumber(trackingNumberInfo) {
            var firstInsertLocation = document.getElementById('duplicatedTrackingNumberContainer');
            if (firstInsertLocation) {
                // Création du lien cliquable avec l'URL de suivi appropriée
                var link = document.createElement('a');
                var url;

                if (trackingNumberInfo.type === 'Colissimo') {
                    url = 'https://www.laposte.fr/outils/suivre-vos-envois?code=' + trackingNumberInfo.number;
                } else if (trackingNumberInfo.type === 'Colis Privé') {
                    url = 'https://colisprive.com/moncolis/pages/detailColis.aspx?numColis=' + trackingNumberInfo.number;
                } else if (trackingNumberInfo.type === 'DPD') {
                    url = 'https://www.dpdgroup.com/nl/mydpd/my-parcels/incoming?parcelNumber=' + trackingNumberInfo.number;
                }

                link.href = url;
                link.textContent = 'Cliquez ici pour suivre sur le site de ' + trackingNumberInfo.type;
                link.target = '_blank'; // Ouvre le lien dans un nouvel onglet

                // Suppression de contenu précédent et ajout du lien
                firstInsertLocation.innerHTML = ''; // Nettoyez l'emplacement pour éviter les doublons
                firstInsertLocation.appendChild(link);
            }

            var secondInsertLocation = document.getElementById('secondTrackingNumberContainer');
            if (secondInsertLocation) {
                // Ajoute juste le texte dans le second conteneur
                secondInsertLocation.textContent = 'Numéro de suivi: ' + trackingNumberInfo.number;
            }
        }
    }
});
